const CHANNEL_MULTIPLIER = parseFloat(process.env.CHANNEL_MULTIPLIER) || 1.0;

const CHANNEL_BASE_PRICING = {
  facebook: 200,
  instagram: 200,
  "google-display": 300,
  youtube: 300,
  "google-search": 400,
  linkedin: 200,
  snapchat: 400,
  reddit: 400,
  "ebay-kleinanzeigen": 300,
  indeed: 400,
  twitter: 250,
  pinterest: 600,
  spotify: 600,
  "linkedin-feed": 2000,
  tiktok: 1000
};
const LINKEDIN_PURCHASE_PRICE = parseInt(process.env.LINKEDIN_PURCHASE_PRICE, 10) || 399;
const MIN_BUDGET_FOUR_CHANNELS = parseInt(process.env.MIN_BUDGET_FOUR_CHANNELS, 10) || 1600; // EUR

const CHANNEL_PRICING = { ...CHANNEL_BASE_PRICING };
Object.keys(CHANNEL_PRICING).forEach((key) => {
  CHANNEL_PRICING[key] = Math.ceil(CHANNEL_PRICING[key] * CHANNEL_MULTIPLIER);
});

const CHANNEL_CPC = {
  facebook: 4,
  instagram: 6,
  "google-display": 3,
  youtube: 3,
  "google-search": 5,
  linkedin: 20,
  snapchat: 4,
  reddit: 5,
  "ebay-kleinanzeigen": 4,
  indeed: 12,
  twitter: 4,
  pinterest: 4,
  spotify: 8,
  "linkedin-feed": 10,
  tiktok: 6
};

const L1_MULTIPLIERS = {
  L1001_L2000_L3000: 1.4, // Azubis
  L1003_L2000_L3000: 1.4, // Finanzdienstleistungen, Rechnungswesen und Steuerberatung
  L1002_L2000_L3000: 1.0, // Bau, Architektur, Vermessung und Gebäudetechnik
  L1004_L2000_L3000: 1.4, // Gesundheit
  L1005_L2000_L3000: 1.5, // IT Jobs
  L1006_L2000_L3000: 1.2, // Land-, Forst- und Tierwirtschaft und Gartenbau
  L1008_L2000_L3000: 0.8, // Produktion und Handwerk
  L1009_L2000_L3000: 0.8, // Schutz und Reinigung
  L1010_L2000_L3000: 1.2, // Soziales, Lehre und Erziehung
  L1011_L2000_L3000: 1.3, // Technische Berufe
  L1012_L2000_L3000: 1.0, // Tourismus-, Hotel- und Gaststättenberufe
  L1013_L2000_L3000: 1.2, // Traditional and New Media Jobs
  L1014_L2000_L3000: 1.1, // Unternehmensorganisation, Recht und Verwaltung
  L1015_L2000_L3000: 1.0, // Vertrieb, Verkauf und Einkauf
  L1016_L2000_L3000: 1.5 // Wissenschaftliche Berufe
};

const CHANNELS_WITH_FIXED_BUDGET = [{ name: "linkedin", budget: LINKEDIN_PURCHASE_PRICE }];

module.exports = {
  CHANNEL_CPC,
  CHANNEL_MULTIPLIER,
  CHANNEL_PRICING,
  CHANNELS_WITH_FIXED_BUDGET,
  LINKEDIN_PURCHASE_PRICE,
  MIN_BUDGET_FOUR_CHANNELS,
  L1_MULTIPLIERS
};
